<!-- Spec §4: fixed glass bottom-nav, 5 slots, sliding orange indicator under active slot. -->
<nav class="bottom-nav" role="navigation" aria-label="Navegação principal">
  <!-- Sliding indicator (orange 14%) sits behind the active slot (CSS :has / routerLinkActive). -->
  <a
    *ngFor="let slot of slots"
    [routerLink]="slot.route"
    routerLinkActive="active"
    class="bottom-nav-item"
    [attr.aria-label]="slot.label"
    [hidden]="!isVisible(slot)"
  >
    <span class="bottom-nav-ind" aria-hidden="true"></span>
    <mat-icon>{{ slot.icon }}</mat-icon>
    <span class="bottom-nav-label">{{ slot.label }}</span>
  </a>

  <!-- 5th slot: "Mais" opens the modules sheet. -->
  <button
    type="button"
    class="bottom-nav-item"
    [class.active]="sheetOpen"
    aria-label="Mais"
    [attr.aria-expanded]="sheetOpen"
    (click)="openSheet()"
  >
    <span class="bottom-nav-ind" aria-hidden="true"></span>
    <mat-icon>apps</mat-icon>
    <span class="bottom-nav-label">Mais</span>
  </button>
</nav>

<!-- Spec §4: "Mais" bottom sheet — all modules grouped, 3-col grid, 74px tiles. -->
<div
  class="sheet-backdrop"
  [class.open]="sheetOpen"
  (click)="closeSheet()"
  aria-hidden="true"
></div>

<div
  class="modules-sheet"
  [class.open]="sheetOpen"
  role="dialog"
  aria-modal="true"
  aria-label="Todos os módulos"
>
  <div class="sheet-handle" aria-hidden="true"></div>

  <header class="sheet-header">
    <h2 class="sheet-title">Módulos</h2>
    <button type="button" class="sheet-close" aria-label="Fechar" (click)="closeSheet()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="sheet-body">
    <ng-container *ngFor="let group of sheetGroups">
      <section class="sheet-group" *ngIf="groupHasVisible(group)">
        <h3 class="sheet-group-label">{{ group.label }}</h3>
        <div class="sheet-grid">
          <a
            *ngFor="let item of group.items"
            [routerLink]="item.route"
            routerLinkActive="active"
            class="sheet-tile"
            [hidden]="!isVisible(item)"
            (click)="closeSheet()"
          >
            <mat-icon>{{ item.icon }}</mat-icon>
            <span class="sheet-tile-label">{{ item.label }}</span>
          </a>
        </div>
      </section>
    </ng-container>
  </div>
</div>
